import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'onClick'
        }
    }

    init() {
    }

    onClick() {
        const id = this.getData('id')
        const platform = this.getData('platform')

        if(window.gtag) {
            gtag("event", "click", {
                "event_category": "video_modal",
                "event_label": `open`,
                "value": id
            });
        }

        this.call('toggle', { id, platform }, 'VideoModal')
    }
}
